import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import logo from './img/logo.svg';
import confirm from './img/confirm.svg';
import cross from './img/cross.svg';
import confirmGreen from './img/confirmGreen.svg';

import './styles.css';

class Header extends Component {
  constructor(props) {
    super(props);

    this.stepClassName = this.stepClassName.bind(this);
    this.renderIcon = this.renderIcon.bind(this);

    this.state = {};
  }

  stepClassName(stepNumber, alternativeStepNumber) {
    let className = 'step';
    if (this.props.step === stepNumber) className += ' step--active';
    if (this.props.step === alternativeStepNumber) className += ' step--active';
    if (this.props.step > stepNumber) className += ' step--done';
    if (this.props.step === 'failed') className += ' step--failed';

    return className;
  }

  renderIcon() {
    if (this.props.step >= 3) {
      return (<img className="step__image" src={confirmGreen} width="13" height="10" alt="Success" />);
    }

    if (this.props.step === 'failed') {
      return (<img className="step__image" src={cross} width="13" height="10" alt="Failed" />);
    }

    return (<img className="step__image" src={confirm} width="13" height="10" alt="Check mark" />);
  }

  render() {
    let className = 'header';
    if (this.props.light) className += ' header--light';

    return (
      <div className={className}>
        <div className="logo">
          <Link className="logo__link" to="/">
            <img className="logo__img" src={logo} width="30" height="30" alt="Tokenblender logo" />
            <span className="logo__name">Tokenblender</span>
          </Link>
        </div>

        {this.props.step ?
          <ul className="steps">
            <li className={this.stepClassName(1)}>1</li>
            <li className={this.stepClassName(2)}>2</li>
            <li className={this.stepClassName(3, 'failed')}>
              {this.renderIcon()}
            </li>
          </ul>
        : null}

        {this.props.error ?
          <div className="error">
            {this.props.error}
          </div>
        : null}
      </div>
    );
  }
}

// <div className="support">
//   <Button
//     type="link"
//     color="light-green"
//     className="support__button"
//     size="medium"
//     href="https://support.tokenblender.com"
//     target="_blank"
//     text="Support"
//   />
// </div>

Header.propTypes = {
  step: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  light: PropTypes.bool,
  error: PropTypes.string,
};

Header.defaultProps = {
  step: 0,
  light: false,
  error: '',
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx